"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenGate = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../common/constants");
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TokenGate = /*#__PURE__*/_react.default.memo(function (_ref) {
  var tokenStatus = _ref.tokenStatus,
    children = _ref.children,
    setBlankToken = _ref.setBlankToken,
    refresh = _ref.refresh,
    setCSRFToken = _ref.setCSRFToken;
  (0, _react.useEffect)(function () {
    if (tokenStatus !== _constants.TOKEN_LOADED) {
      var response = refresh();
      response.then(function (res) {
        var _csrftoken = _lodash.default.get(res, 'payload._csrftoken');
        if (_csrftoken) {
          var payload = {};
          payload.permissions = _lodash.default.get(res, 'payload.permissions');
          payload.generalPermissions = _lodash.default.get(res, 'payload.generalPermissions');
          payload._csrftoken = _csrftoken;
          setCSRFToken(payload);
        } else {
          setBlankToken();
        }
      });
    }
  }, []);
  // Render contents once toggles finish, loader until then, error if it times out
  switch (tokenStatus) {
    case _constants.TOKEN_LOADED:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
    case _constants.TOKEN_LOADING:
    default:
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
        active: true
      }, "Loading...");
  }
});
exports.TokenGate = TokenGate;